export default __webpack_public_path__ + "static/garden_design21-346e8feeb3dda9996cb44b5ab113b612.webp";